import React, { useEffect, useRef } from 'react';

/**
 * ScrollProgress — Thin brass progress bar at top of viewport
 * Fills left-to-right as the user scrolls down the page.
 */
const ScrollProgress = () => {
  const progressRef = useRef(null);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        const bar = progressRef.current;
        if (!bar) {
          ticking = false;
          return;
        }
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const progress = docHeight > 0 ? Math.min(scrollTop / docHeight, 1) : 0;
        bar.style.transform = `scaleX(${progress})`;
        ticking = false;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      ref={progressRef}
      className="scroll-progress"
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '2px',
        width: '100%',
        transform: 'scaleX(0)',
        transformOrigin: 'left center',
        background: 'linear-gradient(90deg, var(--brass-dark, #9B7B3C), var(--brass), var(--brass-light, #D4AF55))',
        zIndex: 10001,
        pointerEvents: 'none',
        willChange: 'transform',
      }}
    />
  );
};

export default ScrollProgress;
